'use client'

// React Imports
import { useRef, useState } from 'react'

// Next Imports
import Link from '@components/Link'

// MUI Imports
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Fade from '@mui/material/Fade'
import IconButton from '@mui/material/IconButton'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'

// Type Imports
import { useTranslation } from 'react-i18next'

// Hook Imports
import { useSettings } from '@core/hooks/useSettings'
import useVerticalNav from '@/@menu/hooks/useVerticalNav'

type LanguageDataType = {
  langCode: any
  langName: string
  flag: string
}

// Vars
const languageData: LanguageDataType[] = [
  {
    langCode: 'en',
    langName: 'English',
    flag: '/images/locales/us.png'
  },
  {
    langCode: 'vi',
    langName: 'Vietnamese',
    flag: '/images/locales/vi.png'
  }
]

const LanguageDropdown = () => {
  // States
  const [open, setOpen] = useState(false)
  const { i18n } = useTranslation()

  const verticalNavOptions = useVerticalNav()
  const { isCollapsed, isHovered } = verticalNavOptions

  // Refs
  const anchorRef = useRef<HTMLButtonElement>(null)

  // Hooks
  const { settings } = useSettings()
  // const { lang } = useParams()

  const handleClose = (langCode: string) => {
    i18n.changeLanguage(langCode)
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  return (
    <>
      <IconButton ref={anchorRef} onClick={handleToggle} className='text-textPrimary rounded-[8px] hover:bg-transparent'>
        {(() => {
          const currentLang = languageData.find(l => l.langCode === i18n.language)

          return currentLang ? (
            <>
              <img
                src={currentLang.flag}
                alt={currentLang.langCode}
                style={{ width: 20, height: 20, marginLeft: 6, borderRadius: '50%' }}
                className='language-dropdown-flag-custom'
              />
              {!(isCollapsed && !isHovered) && (
                <span className='ms-2 text-[15px] language-dropdown-text-custom'>{currentLang.langName}</span>
              )}
            </>
          ) : null
        })()}
      </IconButton>
      <Popper
        open={open}
        transition
        disablePortal
        placement='bottom-start'
        anchorEl={anchorRef.current}
        className='min-is-[240px] z-[1]'
      >
        {({ TransitionProps, placement }) => (
          <Fade
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom-start' ? 'left top' : 'right top' }}
          >
            <Paper className={settings.skin === 'bordered' ? 'border shadow-none' : 'shadow-lg'}>
              <ClickAwayListener onClickAway={() => handleClose}>
                {/* @ts-ignore */}
                <MenuList onKeyDown={handleClose}>
                  {languageData.map(locale => (
                    <MenuItem
                      key={locale.langCode}
                      component={Link}
                      href={'#'}
                      onClick={() => handleClose(locale.langCode)}
                      selected={i18n.language === locale.langCode}
                    >
                      {locale.langName}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  )
}

export default LanguageDropdown
